import { TabItem } from '@components/Tabs/Tabs.types';
import GlobalIntlSingleton from '@setup/intl/GlobalIntlSingleton';
import UserDocuments from '../UserDocuments/UserDocuments';
import UserProfile from '../UserProfile/UserProfile';

export const profileTabs: TabItem[] = [
  {
    id: 1,
    label: GlobalIntlSingleton.intl.formatMessage({
      id: 'profile.personalInformation',
    }),
    component: <UserProfile />,
  },
  {
    id: 2,
    label: GlobalIntlSingleton.intl.formatMessage({
      id: 'profile.legalDocuments',
    }),
    component: <UserDocuments />,
  },
];
